import { OrderStatus } from '../enums/orders';

export const ONLINE_ORDER_SALES_PREFIX = 'OL';
export const RESERVATION_ORDER_SALES_PREFIX = 'OR';

export const VALID_INITIAL_ORDER_STATUS = [
  OrderStatus.DRAFT,
  OrderStatus.CREATED,
];

export const EDITABLE_ORDER_STATUS = [
  OrderStatus.DRAFT,
  OrderStatus.CREATED,
  OrderStatus.IN_PROGRESS,
  OrderStatus.ON_HOLD,
  OrderStatus.ON_ACCOUNT,
];

export const NOTIFIED_ORDER_STATUS = [
  OrderStatus.IN_PROGRESS,
  OrderStatus.COMPLETED,
];
